export default (value) => {
  let realdistance = (value / 1000).toFixed(2)
  if (realdistance < 1000) {
    let dist = parseFloat(realdistance)

    if (dist < 1) {
      return (dist * 1000).toFixed(1) + ' m'
    }

    return (dist.toFixed(1)) + ' km'
  }

  return ''
}


// WEBPACK FOOTER //
// ./src/filters/distanceFilter.js